import React, { useCallback, useState, useEffect } from 'react'
import { Main, BasicEducation, AdditionalEducation, ExtracurricularActivities, Electives } from './ModalTabs'
import cn from 'classnames'
import styles from './styles.module.css'
import Modal from 'react-responsive-modal'
import { educationalStructureModalModes } from '../../assets/const'
import { EducationalStructureContext } from '../../utils/context'
import Confirmation from '../../components/Confirmation/Confirmation'


export default function ModalComponent({ modalOpen, closeModal, isOpen }) {

    const [mode, setMode] = useState('main')
    const [confirmClose, setConfirmClose] = useState(false)
    const handleClose = useCallback(() => setConfirmClose(true), [])
    const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
    const rejectConfirmation = useCallback(() => setConfirmClose(false), [])

    // Несохранённые отметки чекбоксов по вкладкам курирования (basicEducation/additionalEducation/
    // extracurricularActivities/electives), чтобы переключение вкладок без сохранения их не сбрасывало
    const [tabSelections, setTabSelections] = useState({})
    const updateTabSelection = useCallback((tabType, patch) => {
        setTabSelections(prev => ({ ...prev, [tabType]: { ...prev[tabType], ...patch } }))
    }, [])

    // Сбрасываем вкладку на «Главная» и несохранённые отметки при каждом открытии
    useEffect(() => {
        if (isOpen) {
            setMode('main')
            setTabSelections({})
        }
    }, [isOpen])

    // При создании новой записи (нет did) все вкладки кроме «Главная» недоступны
    const addMode = !modalOpen?.did

    const renderLi = ({ name, value, icon }) => {
        const selected = value === mode
        const disabled = addMode && value !== 'main'
        return (
            <li
                onClick={() => !disabled && setMode(value)}
                className={cn(styles.modalMenuItem, {
                    [styles.selectedMenuItem]: selected,
                    [styles.disabledMenuItem]: disabled,
                })}
                title={disabled ? 'Доступно только при редактировании существующей записи' : undefined}
            >
                {icon()}
                {name}
            </li>
        )
    }

    const renderTab = () => {
        switch (mode) {
            case 'main': return <Main />
            case 'basicEducation': return <BasicEducation />
            case 'additionalEducation': return <AdditionalEducation />
            case 'extracurricularActivities': return <ExtracurricularActivities />
            case 'electives': return <Electives />
            default: return
        }
    }

    return (

        <EducationalStructureContext.Provider value={{ closeModal, modalOpen, addMode, tabSelections, updateTabSelection }}>
            <Modal
                open={isOpen}
                onClose={handleClose}
                classNames={{ modal: styles.modalMain }}
                styles={{ overlay: { alignItems: 'center', padding: '12px' } }}
                closeOnOverlayClick={true}
                closeOnEsc={true}
                showCloseIcon={false}
                animationDuration={1}
            >
                <div className={styles.modalContent}>
                    <div className={styles.modalMenu}>
                        <ul>{educationalStructureModalModes.map(renderLi)}</ul>
                    </div>
                    {renderTab()}
                </div>
                {confirmClose && (
                    <Confirmation
                        title="Закрыть без сохранения изменений?"
                        acceptConfirmation={acceptConfirmation}
                        rejectConfirmation={rejectConfirmation}
                    />
                )}
            </Modal>
        </EducationalStructureContext.Provider>
    )
}
